export function scrollTo() {
    const $trigger = jQuery(this);   
    const $scrollTo = jQuery("#" + $trigger.data('scroll-to'));
    const animationTime = $trigger.data('scroll-time') || 1000;
        
    if ($scrollTo.length) {
        jQuery('html, body').animate({
            scrollTop: $scrollTo.offset().top
        }, animationTime, function() {
            $trigger.trigger('icube.utils.scrolledto');
        });
    }              
    
    return false;
}